import { ref } from 'vue'

export default function () {
  return {
    autoDark: ref(false),
    dark: ref('auto'),
    lang: ref('en-US'),
    loading: ref(false),
    header: ref({
      isScrolled: false,
      scrollPosition: 0,
      height: 0
    }),
    sidebar: ref({
      initialWidth: 360,
      minWidth: 180,
      width: 360,
      isReversed: false,
      isActive: true
    }),
    drawerLeft: ref({
      isActive: true,
      isMini: false,
      width: 200,
      miniWidth: 52
    }),
    scrollPosition: ref({ top: 0, left: 0 }),
    pageSize: ref({
      width: 0,
      height: 0,
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      x: 0,
      y: 0
    }),
    instantSearchProps: ref(null),
    breadcrumbs: ref([])
  }
}
